import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { SImageLazy } from '@strana-artw/ui-kit';
import { computed, defineComponent, onMounted, toRefs } from 'vue';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { YM_HIDE_CONTENT } from '@/shared/constants';
import { AppTitle } from '@/shared/ui';
import Instruction from '@/shared/ui/Instruction.vue';
import { PhoneOutput } from '@/shared/ui/outputs';
import { useManualsStore } from '@/store/manuals';
export default /*#__PURE__*/_defineComponent({
  __name: 'CanIHelpYouBanner',
  props: {
    manager: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'CanIHelpYouBanner'
    });
    var manualSlug = 'WORKING_PARTNERS_ACCOUNT';
    var _useManualsStore = useManualsStore(),
      getManual = _useManualsStore.getManual,
      getManualBySlug = _useManualsStore.getManualBySlug;
    var _toRefs = toRefs(useScreenPlugin()),
      isMobile = _toRefs.isMobile;
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return getManual({
              slug: manualSlug
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var manual = computed(function () {
      return getManualBySlug({
        slug: manualSlug
      });
    });
    return {
      __sfc: true,
      manualSlug: manualSlug,
      getManual: getManual,
      getManualBySlug: getManualBySlug,
      isMobile: isMobile,
      manual: manual,
      SImageLazy: SImageLazy,
      YM_HIDE_CONTENT: YM_HIDE_CONTENT,
      AppTitle: AppTitle,
      Instruction: Instruction,
      PhoneOutput: PhoneOutput
    };
  }
});